import React from 'react';

import {
  FooterContainer,
  FooterText
} from './footer.styles';

const Footer = () => (
  <FooterContainer>
    <FooterText>Copyright ©2025</FooterText>
  </FooterContainer>
);

export default Footer;